import React, { Component } from "react";
import AntdTag, {TagProps} from "antd/lib/tag";
import "antd/lib/tag/style";

const { CheckableTag } = AntdTag;
export default class Tag extends Component<TagProps> {
  static CheckableTag = CheckableTag;
  render() {
    return <AntdTag {...this.props} />;
  }
}


// WEBPACK FOOTER //
// ./src/components/tag/index.tsx